export enum DriveItemListOrigin {
	Folder = 'folder',
	Favorites = 'favorites',
	New = 'new',
	Search = 'search',
	Selection = 'selection',
	Downloads = 'downloads',
	Updates = 'updates'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/constants.ts